(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('youtubeVideoListComponent', [
            function() {
                return {
                    restrict: 'E',
                    scope: {
                        name: '@?',
                        url: '@?',
                        data: '='
                    },
                    templateUrl: '/templates/youtubeVideoListComponent.html'
                };
            }]);
})();
